<!-- 已开课程 -->
<template>
  <div class="basicStyle">
    <h1>学员{{$route.query.realname}}已开通商品详情</h1>
    <div class="continue">
        <el-button type="success" @click="buyGoodsBtn" size="mini">继续开通</el-button>
    </div>
    <div>
        <TableComponents :columns="columns" :tableData="tableList" />
    </div>
    <SelectBuyGoods :buyGoodsShow.sync="selectBuyGoodsShow" :goodsNeedId="~~$route.query.uid" v-if="selectBuyGoodsShow" />
    <div class="pagination">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="queryInfo.page"
        :page-sizes="[10, 30, 50, 80]"
        :page-size="queryInfo.limit"
        layout="total, sizes, prev, pager, next, jumper"
        :total="queryInfo.total">
      </el-pagination>
    </div>
  </div>
</template>

<script>
import finalApi from '@/api/financial.js'
import TableComponents from '@/components/TableComponents.vue';
import SelectBuyGoods from '@/components/SelectBuyGoods.vue';
export default {
    name:"StudentDetail",
    components:{
        TableComponents,
        SelectBuyGoods
    },
    data(){
        return{
            queryInfo:{
            limit:10,
            page:1,
            total:0,
            user_no:""
        },
            // 学员开课字段
            selectBuyGoodsShow:false,
            columns:[
                {label:"开通商品",prop:"good_name"},
                {label:'实付价格',prop:'fee'},
                {label:'所属于考试',prop:'subject_cate_name'},
                {label:'商品类型',prop:'goods_type_name'},
                {label:'订单号',prop:'order_no'},
                {label:'学员账号',prop:'user_no'},
                // {label:'累计学习时长',prop:'leann_total_time'},
                {label:'实际扣款时间',prop:'pay_at'},
                {label:'开通时间',prop:'created_at'},
                {label:'到期时间',prop:'due_time'},
                {label:'开通人',prop:'pm_user_id'},
            ],
            tableList:[],
        }
    },
    watch:{
        selectBuyGoodsShow(newval){
            if(!newval){
                this.queryTable()
            }
        }
    },
    created(){
        // this.queryInfo.user_no = this.$route.query.name
        this.queryInfo.user_id = this.$route.query.uid
        this.queryInfo.order_type_info = 1
        //  this.$route,this.queryInfo);
        this.queryTable()
    },
    methods:{
        // 开通会员
        buyGoodsBtn(){
            this.selectBuyGoodsShow = true
        },
        // 列表
        async queryTable(){
            const res = await finalApi.orderList(this.queryInfo)
            if(res.code == 200){
                this.queryInfo.total = res.data.list.total || 0
                this.tableList = res.data.list.data
            }else{
                this.$message.error(res.message)
            }
        },
        // 分页
        handleSizeChange(e){
        //  e);
        this.queryInfo.limit = e
        this.queryTable()
        },
        handleCurrentChange(e){
        this.queryInfo.page = e
        this.queryTable()
        },
    }
}
</script>

<style lang="less" scoped>
.basicStyle{
    .continue{
        margin: 10px 0;
    }
}
</style>